import { render, staticRenderFns } from "./IndicadoresPreventivaArmazem.vue?vue&type=template&id=136769d0&scoped=true&"
import script from "./IndicadoresPreventivaArmazem.vue?vue&type=script&lang=js&"
export * from "./IndicadoresPreventivaArmazem.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresPreventivaArmazem.vue?vue&type=style&index=0&id=136769d0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "136769d0",
  null
  
)

export default component.exports